export default "__VITE_ASSET__wCV318PX__"